import { render } from "./WarningData.vue?vue&type=template&id=484dbcf8&scoped=true&ts=true"
import script from "./WarningData.vue?vue&type=script&lang=ts"
export * from "./WarningData.vue?vue&type=script&lang=ts"

import "./WarningData.vue?vue&type=style&index=0&id=484dbcf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484dbcf8"]])

export default __exports__